import ViewDetails from "../../utils/utilities/ViewDetails";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import ManageHistoryRoundedIcon from '@mui/icons-material/ManageHistoryRounded';

// Tabs
import DetailsTab from "./Tabs/Details";

const tabContent = [
  {panel: "details", content: <DetailsTab />},
]

const ViewVendorPayment = () => {


  const tabs = [
    {label: "Details", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Vendor Payment" identifier="vendor_payment_num" tabs={tabs} tabContent={tabContent} isProfile={false} url="vendor_payments">

    </ViewDetails>
  )
};

export default ViewVendorPayment;